import { render, staticRenderFns } from "./AlertTag.vue?vue&type=template&id=cf6c1da6"
import script from "./AlertTag.vue?vue&type=script&lang=js"
export * from "./AlertTag.vue?vue&type=script&lang=js"
import style0 from "./AlertTag.vue?vue&type=style&index=0&id=cf6c1da6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports